import { t } from './i18n'

export const MAX_FILES = 3
export const MAX_FILE_SIZE = 5 * 1024 * 1024
export const FILE_TYPES = ['image/png', 'image/jpeg', 'image/gif', 'image/webp', 'application/pdf', 'text/plain']

type FileLike = Pick<File, 'name' | 'size' | 'type'>

// Mirrors ContactMessage#attachments_are_acceptable; the server re-checks.
export function fileError(files: FileLike[]): string | null {
  if (files.length > MAX_FILES) return t('contact.too_many', { count: MAX_FILES })
  for (const file of files) {
    if (file.size > MAX_FILE_SIZE) return t('contact.too_big', { name: file.name })
    if (!FILE_TYPES.includes(file.type)) return t('contact.wrong_type', { name: file.name })
  }
  return null
}

export function formError(data: { email?: string | null; subject: string; subjectOther: string; message: string }): string | null {
  if (data.email !== undefined && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(data.email ?? '')) return t('contact.bad_email')
  if (!data.subject) return t('contact.no_subject')
  if (data.subject === 'other' && !data.subjectOther.trim()) return t('contact.no_other')
  if (data.message.trim().length < 10) return t('contact.too_short')
  return null
}
